export const SPRINT_DURATION = 'sprintDuration';
export const COACH_INSIGHTS_FEATURE_FLAG = 'coachInsights';
export const SESSION_RECAP_PREVIEW_FEATURE_FLAG = 'webSessionRecapPreview';
export const IMPROVED_GROUP_VIEW_FEATURE_FLAG = 'improvedGroupView';
export const GOAL_DEEP_DIVE_MARKDOWN_FEATURE_FLAG = 'goalDeepDiveMarkdown';
export const WEIGHTED_CHALLENGES_FEATURE_FLAG = 'weightedChallenges';
export const RATED_CHALLENGES_FEATURE_FLAG = 'iOsEvaluateChallenge';
export const CHAT_WITH_AI_KNOWLEDGE_BASE_FEATURE_FLAG =
  'chatWithAiKnowledgeBase';
export const ASSESSMENT_SPLIT_FLOW_FEATURE_FLAG = 'assessmentSplitFlow';
export const ROUTINES_FEATURE_FLAG = 'routines';
export const OPTIMAL_DAY_BUCKET_FEATURE_FLAG = 'webOptimalDayBucket';
export const NEGATIVE_CHALLENGES_FEATURE_FLAG = 'negativeChallenges';
export const SPRINT_OUTCOMES_FEATURE_FLAG = 'sprintOutcomes';
export const WEEKLY_OUTCOMES_FEATURE_FLAG = 'weeklyOutcomes';
export const MORPHEUS_OBJECTIVES_DASHBOARD_FEATURE_FLAG =
  'webMorpheusObjectivesDashboard';
export const MORPHEUS_3_WAY_CHAT_FEATURE_FLAG = 'morpheus3WayChat';
export const MORPHEUS_3_WAY_CHAT_KEYWORDS_FEATURE_FLAG =
  '3-way-chat-morpheus-keywords';
export const MORPHEUS_INSIGHTS_FEATURE_FLAG = 'webMorpheusInsights';
